class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.motionLists = this.querySelectorAll('motion-list');

    this.details.addEventListener('mouseenter', (event) => {
      const currentDetail = event.currentTarget;
      this.summary.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      event.currentTarget.setAttribute('open', '');
      void currentDetail.querySelector('.mega-menu__list').offsetWidth;
      currentDetail.querySelector('.mega-menu__list').classList.add('animated');
      Motion.animate(this.querySelector('.mega-menu__content'), { visibility: 'visible', transform: ['translateY(-105%)', 'translateY(0)'] }, { duration: 0.6, easing: [.7, 0, .2, 1] }).finished;
      this.motionLists.forEach((motionlist) => {
        motionlist.load();
      });
    });

    this.details.addEventListener('mouseleave', (event) => {
      this.summary.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      const currentDetail = event.currentTarget;
      currentDetail.querySelector('.mega-menu__list').classList.remove('animated');
      Motion.animate(this.querySelector('.mega-menu__content'), { visibility: 'hidden', transform: 'translateY(-105%)' }, { duration: 0.6, easing: [.7, 0, .2, 1] }).finished;
      setTimeout(() => {
        currentDetail.removeAttribute('open');
      }, 600);

      this.motionLists.forEach((motionlist) => {
        motionlist.unload();
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
